module.exports = __webpack_public_path__ + "img/20230901080519561m1c.5b16ba62.jpg";